<template>
  <div>
    <div class="nk-app-root">
      <div class="nk-main">
        <div class="nk-wrap">
          <Header v-show="!loading_page" />
          <div class="nk-content">
            <div class="container wide-xl">
              <div class="nk-content-inner">
                <Navigation v-show="!loading_page" />
                <div class="nk-content-body" v-show="!loading_page">
                  <div class="nk-content-wrap">
                    <div class="nk-block nk-block-lg">
                      <div class="nk-block-head">
                        <div class="nk-block-head-content">
                          <h4 class="nk-block-title">{{ $t('dm_auditlog_title') }}</h4>
                        </div>
                      </div>

                      <div class="row mb-3">
                        <div class="col-sm-3">
                          <input type="text" class="form-control" :placeholder="$t('dm_common_col_serial_number')" v-model="filterSeriennummer" />
                        </div>
                        <div class="col-sm-3">
                          <input type="text" class="form-control" :placeholder="$t('dm_auditlog_filter_user')" v-model="filterBenutzer" />
                        </div>
                        <div class="col-sm-2">
                          <select class="form-control" v-model="filterCollection">
                            <option value="">{{ $t('dm_common_all') }}</option>
                            <option value="anlagen">{{ $t('dm_common_anlagen') }}</option>
                            <option value="parks">{{ $t('dm_common_parks') }}</option>
                            <option value="adressen">{{ $t('dm_common_adressen') }}</option>
                            <option value="dokumente">{{ $t('dm_common_dokumente') }}</option>
                            <option value="preislisten">{{ $t('dm_common_preislisten') }}</option>
                          </select>
                        </div>
                        <div class="col-sm-2">
                          <select class="form-control" v-model="filterAktion">
                            <option value="">{{ $t('dm_common_all') }}</option>
                            <option value="insert">{{ $t('dm_auditlog_action_created') }}</option>
                            <option value="update">{{ $t('dm_auditlog_action_changed') }}</option>
                            <option value="delete">{{ $t('dm_auditlog_action_deleted') }}</option>
                            <option value="confirm">{{ $t('dm_auditlog_action_confirmed') }}</option>
                          </select>
                        </div>
                        <div class="col-sm-2">
                          <button class="btn btn-primary btn-block" @click="loadAuditLog">
                            <em class="icon ni ni-search"></em> {{ $t('dm_common_btn_search') }}
                          </button>
                        </div>
                      </div>

                      <div class="card card-bordered">
                        <div class="dm-table-wrap">
                          <table class="dm-table">
                            <thead>
                              <tr>
                                <th v-for="col in tableColumns" :key="col.field" @click="toggleSort(col.field)" class="dm-table-th">
                                  {{ col.label }}
                                  <span v-if="sortField === col.field" class="dm-sort-icon">{{ sortAsc ? '&#9650;' : '&#9660;' }}</span>
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="(row, idx) in filteredData" :key="row._id || idx" class="dm-table-row">
                                <td v-for="col in tableColumns" :key="col.field">{{ getCellValue(row, col) }}</td>
                              </tr>
                              <tr v-if="filteredData.length === 0">
                                <td :colspan="tableColumns.length" class="text-center text-muted py-4">{{ $t('dm_common_no_entries_found') }}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>

                      <div class="mt-3 d-flex justify-content-between" v-if="auditEntries.length > 0">
                        <button class="btn btn-sm btn-outline-secondary" @click="loadMore" :disabled="!hasMore">
                          {{ $t('dm_auditlog_btn_load_more') }}
                        </button>
                        <span class="text-muted">{{ auditEntries.length }} {{ $t('dm_auditlog_of') }} {{ total }} {{ $t('dm_auditlog_entries') }}</span>
                      </div>
                    </div>
                  </div>
                  <Footer />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "../../../components/Header.vue";
import Navigation from "../../../components/Navigation.vue";
import Footer from "../../../components/Footer.vue";
import dmTableMixin from "@/mixins/dm-table-mixin";
import dmPermissionsMixin from "@/mixins/dm-permissions-mixin";
import { getAuditLog } from "@/services/dm.service";

export default {
  name: "DmAuditLog",
  components: { Header, Navigation, Footer },
  mixins: [dmTableMixin, dmPermissionsMixin],
  data() {
    return {
      fullLoader: null,
      auditEntries: [],
      filterSeriennummer: "",
      filterBenutzer: "",
      filterCollection: "",
      filterAktion: "",
      limit: 100,
      skip: 0,
      total: 0,
      hasMore: false,
    };
  },
  computed: {
    loading_page() {
      return this.$store.state.loading_page && this.$store.state.loading_page == "setup";
    },
    tableColumns() {
      var self = this;
      return [
        { label: self.$t('dm_common_col_date'), field: "zeitstempel", formatter: function(val) { return val ? new Date(val).toLocaleString("de-DE") : ""; } },
        { label: self.$t('dm_auditlog_col_user'), field: "benutzer_name" },
        { label: self.$t('dm_auditlog_col_action'), field: "aktion" },
        { label: self.$t('dm_auditlog_col_area'), field: "collection_name", formatter: function(val) { var m = { dm_anlagen: self.$t('dm_common_anlagen'), dm_parks: self.$t('dm_common_parks'), dm_adressen: self.$t('dm_common_adressen'), dm_dokumente: self.$t('dm_common_dokumente'), dm_preislisten: self.$t('dm_common_preislisten') }; return m[val] || val || ""; } },
        { label: self.$t('dm_common_col_serial_number'), field: "seriennummer" },
        { label: self.$t('dm_common_col_type'), field: "anlage_typ" },
        { label: self.$t('dm_auditlog_col_changed_fields'), field: "geaenderte_felder", formatter: function(val) { return val ? Object.keys(val).join(", ") : ""; } },
      ];
    },
    filteredData() {
      return this.filterAndSort(this.auditEntries, this.tableColumns);
    },
  },
  created() {
    this.loadAuditLog();
  },
  methods: {
    buildFilters() {
      var filters = { limit: this.limit, skip: this.skip };
      if (this.filterSeriennummer) filters.seriennummer = this.filterSeriennummer;
      if (this.filterBenutzer) filters.benutzer = this.filterBenutzer;
      if (this.filterCollection) filters.collection = this.filterCollection;
      if (this.filterAktion) filters.aktion = this.filterAktion;
      return filters;
    },
    loadAuditLog() {
      this.skip = 0;
      this.auditEntries = [];
      this.fetchAuditLog();
    },
    fetchAuditLog() {
      this.showLoader();
      getAuditLog(this.buildFilters())
        .then((d) => {
          this.hideLoader();
          if (d.data && d.data.list) {
            this.auditEntries = this.auditEntries.concat(d.data.list);
            this.total = d.data.total || 0;
            this.hasMore = !!d.data.hasMore;
          }
        })
        .catch((e) => {
          this.hideLoader();
          this.$store.dispatch("api_error", e);
        });
    },
    loadMore() {
      this.skip += this.limit;
      this.fetchAuditLog();
    },
  },
};
</script>

<style scoped>
.dm-table-wrap {
  max-height: calc(100vh - 220px);
  overflow: auto;
}

.dm-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 15px;
  table-layout: fixed;
}

.dm-table th,
.dm-table td {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dm-table thead {
  background: #f8f9fa;
  border-bottom: 2px solid #e2e8f0;
  position: sticky;
  top: 0;
  z-index: 1;
}

.dm-table-th {
  padding: 12px 16px;
  text-align: left;
  font-weight: 600;
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #64748b;
  cursor: pointer;
  user-select: none;
  white-space: nowrap;
}

.dm-table-th:hover {
  color: #334155;
}

.dm-sort-icon {
  font-size: 10px;
  margin-left: 4px;
  color: #E8751A;
}

.dm-table tbody td {
  padding: 12px 16px;
  border-bottom: 1px solid #f1f5f9;
  color: #334155;
}

.dm-table-row {
  transition: background 0.15s;
}

.dm-table-row:hover {
  background: #f8fafc;
}
</style>
